// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"ece68034","535":"531e334a","577":"531e334a","642":"26dd5ceb","671":"9d999de2","943":"aba1bc1f"}[chunkId] + ".chunk.css";
};